import { useMemo } from "react"

export function useOffsetMarkers(markers: any[]) {
  return useMemo(
    () =>
      markers.map((marker: any, _, arr) => {
        if (
          arr.find(
            a =>
              a.latitude === marker.latitude && a.longitude === marker.longitude
          )
        ) {
          return {
            ...marker,
            latitude: marker.latitude + Math.random() / 10000,
            longitude: marker.longitude + Math.random() / 10000,
          }
        }
        return marker
      }),
    [markers]
  )
}
